import React, { useEffect, useState } from 'react';
import { CheckCircle2, AlertCircle, Info, X } from 'lucide-react';
import { subscribeToasts, dismissToast } from '../utils/toast.js';

const ICONS = {
  success: <CheckCircle2 size={18} />,
  error: <AlertCircle size={18} />,
  info: <Info size={18} />,
};

const ToastContainer = () => {
  const [toasts, setToasts] = useState([]);

  useEffect(() => subscribeToasts(setToasts), []);

  useEffect(() => {
    const timers = toasts.map(t =>
      setTimeout(() => dismissToast(t.id), t.duration)
    );
    return () => timers.forEach(clearTimeout);
  }, [toasts]);

  if (toasts.length === 0) return null;

  return (
    <>
      <style>{`
        .toast-stack { position: fixed; top: 18px; right: 18px; z-index: 4000; display: flex; flex-direction: column; gap: 10px; max-width: min(360px, calc(100vw - 24px)); }
        @media (max-width: 640px) { .toast-stack { top: auto; bottom: 18px; right: 12px; left: 12px; max-width: none; } }
        .toast-item { display: flex; align-items: flex-start; gap: 10px; padding: 13px 14px; border-radius: 14px; background: #ffffff; box-shadow: 0 10px 30px rgba(0,0,0,0.15), 0 0 0 1px rgba(50,97,77,0.08); font-family: 'Sora', system-ui, sans-serif; animation: toastSlideIn 0.25s cubic-bezier(0.34,1.56,0.64,1); cursor: pointer; }
        @keyframes toastSlideIn { from { opacity: 0; transform: translateY(-10px) scale(0.97); } to { opacity: 1; transform: translateY(0) scale(1); } }
        .toast-icon { flex-shrink: 0; display: flex; align-items: center; justify-content: center; width: 28px; height: 28px; border-radius: 9px; margin-top: 1px; }
        .toast-item--success .toast-icon { background: rgba(50,97,77,0.12); color: #2e7d32; }
        .toast-item--error .toast-icon { background: rgba(239,68,68,0.12); color: #dc2626; }
        .toast-item--info .toast-icon { background: rgba(50,97,77,0.12); color: #32614d; }
        .toast-message { flex: 1; font-size: 13px; line-height: 1.45; color: #1a3d2e; font-weight: 500; word-break: break-word; }
        .toast-close { flex-shrink: 0; background: transparent; border: none; color: #9aaa9f; cursor: pointer; padding: 3px; display: flex; align-items: center; justify-content: center; border-radius: 6px; transition: background 0.15s, color 0.15s; }
        .toast-close:hover { background: rgba(0,0,0,0.06); color: #444; }
      `}</style>
      <div className="toast-stack">
        {toasts.map(t => (
          <div
            key={t.id}
            className={`toast-item toast-item--${t.type}`}
            onClick={() => dismissToast(t.id)}
          >
            <span className="toast-icon">{ICONS[t.type] || ICONS.info}</span>
            <span className="toast-message">{t.message}</span>
            <button
              className="toast-close"
              aria-label="Dismiss"
              onClick={(e) => { e.stopPropagation(); dismissToast(t.id); }}
            >
              <X size={14} />
            </button>
          </div>
        ))}
      </div>
    </>
  );
};

export default ToastContainer;
